import { Component } from 'react';
import { GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro';
import { Box } from '@mui/material';

class DataGridExportButton extends Component {
  render() {
    return (
      <Box alignSelf={'flex-end'} px={2} py={1}>
        <GridToolbarContainer>
          <GridToolbarExport
            printOptions={{ disableToolbarButton: true }}
            csvOptions={{
              fileName: this.props.fileName,
            }}
          />
        </GridToolbarContainer>
      </Box>
    );
  }
}

export default DataGridExportButton;
